module.exports = __webpack_public_path__ + "static/media/Mat_rhino_diffuse.bbd79f86.png";